import { useAsyncData } from '@redneckz/uni-jsx/lib/hooks/useAsyncData';
import { fetchJSONUnsafe } from '../utils/fetchJSON.js';
const REGIONS_URL = '/api/v1/regions';
export function useRegions(url = REGIONS_URL) {
    const { data } = useAsyncData(url, fetchJSONUnsafe);
    return Array.isArray(data) ? data : [];
}
//# sourceMappingURL=useRegions.js.map